<template>
  <div>
    <card v-for="item in skeletonList" :key="item">
      <article class="media">
        <figure class="media-left">
          <div class="image is-40x40 is-circular" >
            <div class="skeleton-img">
            </div>
          </div>
        </figure>
        <div class="media-content">
          <div class="content left is-fullwidth">
            <strong class="content-title skeleton-email"></strong>
            <slot name="leftTitle"></slot>
            <span  class="content-subtitle skeleton-email"></span>
            <slot name="leftSubtitle"></slot>
          </div>
          <div v-if="right" class="content has-text-right pl-50">
            <strong class="skeleton-name"></strong>
            <br>
            <span class="content-subtitle skeleton-name"></span>
          </div>
        </div>
      </article>
    </card>
  </div>
</template>

<script>
import Card from '@/components/general/card'
import {skeletonList} from '@/constants/array-constants'

export default {
  name: 'row-skeleton',
  components: {
    Card
  },
  props: {
    right: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      skeletonList
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

strong {
  color: $black;
}

.has-text-right{
  display: flex !important;
  justify-content: flex-end !important;
}

.content {
  max-width: 35vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.content-subtitle, .content-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.media-content {
  height: 100%;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}
.media-content > div {
  width: 50%;
}

.media div.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 0;
  height: 100%;
  height: 40px;
}
.is-fullwidth {
  max-width: 100%;
}
@media screen and (max-width: $tablet) {
  .content {
    max-width: none;
  }
  .content.left {
    margin-right: 4px;
    max-width: 60%;
  }
}
.jobs {
  .list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;

    li {
      flex-basis: 20rem;
      margin-bottom: 1rem;
      border: 1px solid #ddd;
      background-color: #fff;
      margin-right: 1rem;
      border-radius: .5rem;
    }
  }
}

h2.heading {
  margin-bottom: 16px;
}

.column {
  padding: 0.5rem;
}

.column {
  margin-bottom: 2px;
}

@media (max-width:480px)  {
  .jobs .list > li {
    flex-grow: 1;
  }
}

@keyframes loading {
  0% {
    transform: translateX(0);
  }
  50%,
  100% {
    transform: translateX(460px);
  }
}

.skeleton-item {
  display: flex;
  align-items: center;
  margin: 15px 0;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  position: relative;
}

.skeleton-img::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 100%;
  background: linear-gradient(to right, #f2f2f2, #ddd, #f2f2f2);
  animation: loading 2s infinite linear;
}

.skeleton-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f2f2f2;
  position: relative;
  overflow: hidden;
}

.skeleton-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
}

.skeleton-name {
  width: 100%;
  height: 18px;
  background: #f2f2f2;
  position: relative;
  overflow: hidden;
}

.skeleton-name::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 100%;
  background: linear-gradient(to right, #f2f2f2, #ddd, #f2f2f2);
  animation: loading 2s infinite linear;
}

.skeleton-email {
  width: 40%;
  height: 18px;
  background: #f2f2f2;
  margin-top: 3px;
  position: relative;
  overflow: hidden;
}

.skeleton-email::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 100%;
  background: linear-gradient(to right, #f2f2f2, #ddd, #f2f2f2);
  animation: loading 2s infinite linear;
}
.container{
  display: flex;
  flex-direction: column;
}
.mt-2{
  margin-top: 16px;
}

.mb-2{
  margin-bottom: 16px;
}
hr{
  margin-bottom: 0px;
}

.pl-50{
  padding-left: 30% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/general/row-skeleton.vue